import cx from 'classnames';
import React from 'react';

import { Column } from './DataGrid';
import styles from './styles.css';
import { ProjectLine } from '../../../../../Types/project';

interface Props {
  line: ProjectLine;
  columns: Column[];
}

const DataGridRow = ({ line, columns }: Props) => {
  return (
    <div
      className={styles['data-grid-row']}
      style={{ gridTemplateColumns: `6px minmax(360px, 1fr) repeat(${columns.length - 1}, 156px)` }}
    >
      {columns.map((column) => (
        <div
          key={column.id}
          className={cx(styles['data-grid-column'], {
            [styles['data-grid-column--end']]: column.align === 'end',
          })}
        >
          {column.line(line)}
        </div>
      ))}
    </div>
  );
};

export default DataGridRow;
